import { AppLayout } from "core";
import { ReactComponent as MyList } from "src/assets/dist/ic_collection.svg";
import { ReactComponent as Home } from "src/assets/dist/ic_home.svg";
import { ReactComponent as Search } from "src/assets/dist/ic_search.svg";
import { ReactComponent as BnPlus } from "src/assets/dist/ic_blacknut_plus.svg";
import { ReactComponent as LeMag } from "src/assets/dist/ic_lemag.svg";

import NavLink from "../../NavLink";
import styles from "../styles.module.scss";
import React from "react";
import { UserProfile } from "@blacknut/javascript-sdk/dist";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

export interface NavsLinksProps {
  layout: AppLayout;
  pathname: string;
  activeItem: string;
  lemag: boolean;

  profile: UserProfile | undefined;
  blacknutPlus: boolean;
  className?: string;
}

const NavsLinksMobile = ({
  pathname,
  activeItem,
  lemag,
  blacknutPlus,
  className,
}: NavsLinksProps) => {
  const { t } = useTranslation();
  return (
    <div className={clsx(styles.isOnMobil, className)}>
      <NavLink
        to="/catalog"
        replace={pathname === "/catalog"}
        isActive={() => activeItem === "catalog"}
        data-testid="catalog"
      >
        <Home className="svg" />
        <span className={clsx(styles.label)}>{t("menu.catalog")}</span>
      </NavLink>

      {blacknutPlus && (
        <NavLink
          to="/plus"
          replace={pathname === "/plus"}
          isActive={() => activeItem === "plus"}
        >
          <BnPlus className="svg" />
          <span className={clsx(styles.label)}>{t("menu.plus")}</span>
        </NavLink>
      )}

      {lemag && !blacknutPlus && (
        <NavLink
          to="/lemag"
          replace={pathname === "/lemag"}
          isActive={() => activeItem === "lemag"}
          data-testid="lemag"
        >
          <LeMag className="svg" />
          <span className={clsx(styles.label)}>{t("menu.lemag")}</span>
        </NavLink>
      )}

      <NavLink
        replace={pathname === "/myList"}
        to="/myList"
        isActive={() => activeItem === "myList"}
        data-testid="myList"
        requiresAnonymousCheck={true}
      >
        <MyList className="svg" />
        <span className={clsx(styles.label)}>{t("menu.mylist")}</span>
      </NavLink>

      <NavLink
        to="/search"
        replace={pathname === "/search"}
        isActive={() => activeItem === "search"}
        data-testid="search"
      >
        <Search className="svg" />
        <span className={clsx(styles.label)}>{t("menu.search")}</span>
      </NavLink>
    </div>
  );
};

export default NavsLinksMobile;
